import { Colors } from "./types/colorTypes";

/**
 * We provide a variety of palete `colors` and some shadows!
 *
 * *Example*: `import  { colors } from '@kietpt2003/react-native-core-ui/themes'`
 */
export const colors: Colors = {
  // white
  default: '#F1F1F1',
  white: '#FFFFFF',
  white_80: 'rgba(255, 255, 255, 0.8)',

  // black
  black: '#000000',
  black_262626: '#262626',

  // transparent
  transparent00: 'rgba(0, 0, 0, 0)',
  transparent10: 'rgba(0, 0, 0, 0.1)',
  transparent25: 'rgba(0, 0, 0, 0.25)',
  transparent30: 'rgba(0, 0, 0, 0.3)',
  transparent40: 'rgba(0, 0, 0, 0.4)',
  transparent50: 'rgba(0, 0, 0, 0.5)',
  transparent80: 'rgba(0, 0, 0, 0.8)',

  // red
  red_FF6262: '#FF6262',
  red_E00102: '#E00102',
  red_E90000: '#E90000',
  red_FF0303: '#FF0303',
  red_EB4D3D: '#EB4D3D',
  red_ED1C1C: '#ED1C1C',
  red_F26122: '#F26122',
  red_FF3F30: '#FF3F30',
  red_FF4D4F: '#FF4D4F',
  red_FF6E30: '#FF6E30',
  red_F24822: '#F24822',

  // green
  green_32B14A: '#32B14A',
  green_00A720: '#00A720',
  green_42A046: '#42A046',
  green_4CD964: '#4CD964',
  green_8AAD0B: '#8AAD0B',
  green_7FBA00: '#7FBA00',
  green_3CB371: '#3CB371',
  green_7BC143: '#7BC143',
  green_387C2B: '#387C2B',
  green_50A91A: '#50A91A',
  green_2D880C: '#2D880C',
  green_389E0D: '#389E0D',
  green_42A013: '#42A013',
  green_52C41A: '#52C41A',
  green_279C2E: '#279C2E',
  green_266431: '#266431',
  green_32A702: '#32A702',
  green_3C7700: '#3C7700',
  green_3AA015: '#3AA015',
  green_30C75E: '#30C75E',
  green_81B214: '#81B214',
  green_28C76F: '#28C76F',
  green_6CC149: '#6CC149',
  green_B2C8B8: '#B2C8B8',
  green_6AD36E: '#6AD36E',
  green_6ECA67: '#6ECA67',
  green_419522: '#419522',
  green_266432: '#266432',
  green_386338: '#386338',
  green_28663B: '#28663B',
  green_266643: '#266643',
  green_08674F: '#08674F',
  green_206A5D: '#206A5D',
  green_194527: '#194527',
  green_1A4D2E: '#1A4D2E',
  green_91C788: '#91C788',
  green_D0F4C2: '#D0F4C2',
  green_C7F9CC: '#C7F9CC',
  green_CBFFDA: '#CBFFDA',
  green_9AD7AC: '#9AD7AC',
  green_A7E8B9: '#A7E8B9',
  green_A0E8AD: '#A0E8AD',
  green_92E3A973: '#92E3A973',
  green_7BC1431A: '#7BC1431A',
  green_0B5270: '#0B5270',
  green_E0FEE8: '#E0FEE8',
  green_EBF6E3: '#EBF6E3',
  greenlightF8ECD2: '#F8ECD2',
  green_gradient: ['#7BC143', '#387C2B'],
  green_gradient_2: ['#42A046', '#42A046'],

  // blue
  blue: '#00B4F0',
  blue_29ABE2: '#29ABE2',
  blue_00A7E1: '#00A7E1',
  blue_3677BC: '#3677BC',
  blue_DDF7FF: '#DDF7FF',
  blue_2B65B2: '#2B65B2',
  blue_B2E5F6: '#B2E5F6',
  blue_86D3EE: '#86D3EE',
  blue_80D3F0: '#80D3F0',
  blue_1890FF: '#1890FF',

  // yellow
  yellow_EDDE5D: '#EDDE5D',
  yellow_FFCC29: '#FFCC29',
  yellow_F0BD26: '#F0BD26',
  yellow_F6BF32: '#F6BF32',

  // orange
  orange_EB996E: '#EB996E',
  orange_F98B0A: '#F98B0A',
  orange_F58634: '#F58634',
  orange_FFA500: '#FFA500',
  orangeFAAE4F: '#FAAE4F',

  // grey
  gray: '#6E6E6E',
  gray_BCBCBC: '#BCBCBC',
  gray_7E7E7E: '#7E7E7E',
  gray_E5E0E4: '#E5E0E4',
  gray_F1F1F1: '#F1F1F1',
  gray_E7E3E3: '#E7E3E3',
  gray_3C3C3C: '#3C3C3C',
  gray_CCCCCC: '#CCCCCC',
  gray_FAFAFA: '#FAFAFA',
  gray_FDFDFD: '#FDFDFD',
  gray_D9D9D9: '#D9D9D9',
  gray_D9D9D980: '#D9D9D980',
  gray_E6E6E6: '#E6E6E6',
  gray_EBEBEB: '#EBEBEB',
  gray_F5F5F5: '#F5F5F5',
  gray_EEEEEE: '#EEEEEE',
  gray_727272: '#727272',
  gray_9CA3A5: '#9CA3A5',
  gray_E5E5E5: '#E5E5E5',
  gray_D1D2D4: '#D1D2D4',
  gray_A0A0A0: '#A0A0A0',
  gray_EAEAEA: '#EAEAEA',
  gray_B3B3B3: '#B3B3B3',
  gray_8A8A8A: '#8A8A8A',
  gray_E4E4E4: '#E4E4E4',
  gray_888888: '#888888',
  gray_F4F4F4: '#F4F4F4',
  gray_4F4F4F: '#4F4F4F',
  gray_DDDDDD: '#DDDDDD',
  gray_E1E5EA: '#E1E5EA',

  //purple
  purple_222C67: '#222C67',
  purple_9370DB: '#9370DB',

  //shadow
  shadow: {
    elevation: 4,
    shadowColor: '#000',
    shadowOpacity: 0.2,
    shadowRadius: 3.84,
    shadowOffset: {
      width: 0,
      height: -1,
    },
  },

  shadow_btn: {
    elevation: 4,
    shadowColor: '#000',
    shadowOpacity: 0.25,
    shadowRadius: 2,
    shadowOffset: {
      width: 0,
      height: 4,
    },
  },

  shadow_order: {
    elevation: 3,
    shadowColor: '#000',
    shadowOpacity: 0.15,
    shadowRadius: 2.84,
    shadowOffset: {
      width: 0,
      height: 1,
    },
  },

  shadow_btn_small: {
    elevation: 3,
    shadowColor: '#000',
    shadowOpacity: 0.25,
    shadowRadius: 2,
    shadowOffset: {
      width: 1,
      height: 1,
    },
  },
};

export default colors;